<template>
  <div>
    <!-- 订单调整 -->
    <el-dialog :title="$t('message.orderAdjust')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="allot" v-if="isP == false">
        <el-select v-model="allotVal.y_id" filterable :placeholder="$t('message.salesman')">
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="allotVal.p_id" filterable :placeholder="$t('message.distributionMember')">
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot" v-if="isP == false">
        <el-select v-model="allotVal.g_id" filterable :placeholder="$t('message.buyer')">
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="adjustOrderAdmin" v-if="!isP">{{
          $t("message.save")
        }}</el-button>
        <el-button type="primary" @click="adjustOrderP" v-else>{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isP: false,
      allotVal: {
        order_sn_set: [],
        y_id: "",
        g_id: "",
        p_id: "",
      },
      dialogVisible: false
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  methods: {
    // 分配
    adjustOrderAdmin() {
      this.$api.orderApi.adjustOrderAdmin(this.allotVal).then((res) => {
        this.$message.success(res.msg)
        this.dialogVisible = false;
        this.$parent.selectList = [];
        this.$parent.orderList();
      });
    },
    //批量调整配货员
    adjustOrderP() {
      this.$api.orderApi.adjustOrderP(this.allotVal).then((res) => {
        this.$message.success(res.msg)
        this.dialogVisible = false;
        this.$parent.selectList = [];
        this.$parent.orderList();
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.allot {
  margin: 0px 20px 20px;

  .el-select {
    width: 100%;
  }
}
</style>